import { render, staticRenderFns } from "./LaCopro.vue?vue&type=template&id=511941be&scoped=true&"
import script from "./LaCopro.vue?vue&type=script&lang=ts&"
export * from "./LaCopro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511941be",
  null
  
)

export default component.exports